import { createFileRoute } from '@tanstack/react-router';
import { FiveSHomePage } from '@/features/home/home-page';
import { PlainLayout } from '@/features/shell/plain-layout';

/** `/`: resume the last workspace (or the first one); switching happens in the sidebar's selector. */
export const Route = createFileRoute('/_app/')({
    component: function HomeRoute() {
        return (
            <PlainLayout>
                <FiveSHomePage />
            </PlainLayout>
        );
    },
});
